import ReactGA from 'react-ga';
import config from '../../config'

export const initialiseAviationGoogleAnalyticsWithCustomerProdTrackingId = (merchantCode,customerProdGoogleAnalyticsUATrackingId) =>{
    const isProductionEnv = config.deployment_env.toLowerCase() === "prod";
    const optionsForAll = {siteSpeedSampleRate: 100, storage:'none' };

    const trackers = [	
        {	                            //PROD             //PRE-PROD
          trackingId: isProductionEnv ? 'UA-132987861-7' : "UA-132987861-6", // All Enterprise Aviation	
          gaOptions: {... optionsForAll, name: "aviation" },
        }	
      ];

      const urlParams = new URLSearchParams(window.location.search);
      const utmMedium = urlParams.get("utm_medium") ? urlParams.get("utm_medium") : 'unknown';
      const utmCampaign= urlParams.get("utm_campaign");

      if(isProductionEnv && customerProdGoogleAnalyticsUATrackingId){
        trackers.push(
            {	
                trackingId: customerProdGoogleAnalyticsUATrackingId, //Customer specific
                gaOptions: {... optionsForAll, name: "customer" },
              }
        )
      }

      ReactGA.initialize(trackers,{ alwaysSendToDefaultTracker: false });

      ReactGA.set({campaignName:utmCampaign, campaignSource: merchantCode, campaignMedium:utmMedium },['aviation']); //don't want/need to tell a customer their own merchant code
      ReactGA.set({campaignName:utmCampaign, campaignSource: 'default', campaignMedium:utmMedium },['customer']); //don't want/need to tell a customer their own merchant code
}